import { Vue, Component, Watch } from "vue-property-decorator";
import Grid from "@/components/wijmo-grid/grid/grid.vue";
import { MediaModule } from "@/modules/media";
import { GridColumnBinding, MediaSlotBinding, MediaTypeBinding } from "./utils/const";
import { MediaSlotTypeMap } from "@/util/constants";
import { MediaSlotGridModel } from "./utils/model";
import MediaUploader from "@/views/text-guardian/sub-views/non-curriculum/sub-views/media/sub-views/media-uploader.vue";
import { MediaSlot } from "@/util/enum";
import { MediaLocale, MediaTabLocale } from "@/locales/localeid";
import { getModule } from "vuex-module-decorators";
import TitleListState from "@/modules/title-list";
import { disabledDueToAccessLevel, getRouteAccessLevel } from "@/util/func";
import { ContentService } from "@/services/content/service";
import { HasPdfContentResponseModel } from "@/services/media-uploader";

@Component({
	components: {
		Grid,
		MediaUploader
	}
})
export default class MediaTab extends Vue {
	private titleListModule = getModule(TitleListState) as TitleListState;
	public itemSource: MediaSlotGridModel[] = [];
	public uploadDrawerVisible: boolean = false;
	public mediaSlotId?: MediaSlot = undefined;
	public currentComponentId?: string = undefined;
	public pdfSlots: HasPdfContentResponseModel[] = []

	created() {
		this.currentComponentId = this.$route.params.id;
	}

	async mounted() {
		this.onChapterChange();
	}

	get module() {
		return MediaModule;
	}
	get MediaLocale() {
		return MediaLocale;
	}
	get MediaTabLocale() {
		return MediaTabLocale;
	}
	get Binding() {
		return GridColumnBinding;
	}

	get currentRouteAccessLevel() {
		return getRouteAccessLevel(this.$route);
	}

	get disabledDueToAccessLevel() {
		return disabledDueToAccessLevel(this.currentRouteAccessLevel);
	}

	@Watch("module.componentMediaSlots", { immediate: true })
	onMediaSlotUpdate() {
		this.itemSource = this.module.componentMediaSlots.mediaSlots
			.sort((a, b) => a.mediaSlotId - b.mediaSlotId)
			.map(
				(slot) =>
					({
						mediaSlotId: slot.mediaSlotId,
						mediaSlot: this.$format(MediaSlotBinding[slot.mediaSlotId]),
						fileType: this.$format(MediaTypeBinding[MediaSlotTypeMap[slot.mediaSlotId]]),
						existsValue: slot.exists
							? this.$format(MediaTabLocale.MediaTabYes)
							: this.$format(MediaTabLocale.MediaTabNo)
					} as MediaSlotGridModel)
			);
	}

	async uploadSlotMedia(mediaSlotId) {
		const hasPdfValue = await this.hasPdf(mediaSlotId)
		if(!hasPdfValue && mediaSlotId === MediaSlot.IndividualAudio) {
			this.uploadDrawerVisible = false;
			this.mediaSlotId = mediaSlotId;
			return;
		}
		this.uploadDrawerVisible = true;
		this.mediaSlotId = mediaSlotId;
	}

	onDrawerClose(isSaved: boolean = false) {
		this.uploadDrawerVisible = false;
		this.mediaSlotId = undefined;
		if (isSaved) {
			this.onChapterChange();
		}
	}

	@Watch("titleListModule.editeContentSelectedChapterId")
	async onChapterChange() {
		let componentId = this.$route.params.id;

		if (
			this.titleListModule.editeContentSelectedChapterId !== "none" &&
			this.titleListModule.editeContentSelectedChapterId !== "all"
		) {
			componentId = this.titleListModule.editeContentSelectedChapterId;
		}
		this.currentComponentId = componentId;
		await MediaModule.fetchComponentMediaSlots(componentId);
	}

	async hasPdf(mediaSlotId) {
		let hasPdfMedia = true;
		const pdfMediaSlots = [MediaSlot.ViewingContent, MediaSlot.AudioBackground, MediaSlot.TeacherManual]

		if(mediaSlotId !== MediaSlot.IndividualAudio) {
			return true;
		}

		if(this.currentComponentId) {
			hasPdfMedia = false;
			await ContentService.HasPDFContents(this.currentComponentId, pdfMediaSlots)
			.then((data: HasPdfContentResponseModel[]) => {
				this.pdfSlots = data;
				if(!this.pdfSlots.length) {
					return hasPdfMedia
				}

				hasPdfMedia = true;
			})
		}

		return hasPdfMedia
	}
}
